import React from "react";
import { ArrowUp, ArrowDown, Minus } from "lucide-react";
import { useT } from "@/i18n/I18nContext";

export default function KPICard({ icon: Icon, label, value, trend, trendLabel, accent = "#0B7E8C", testId }) {
  const t = useT();
  const trendIcon = trend > 0 ? ArrowUp : trend < 0 ? ArrowDown : Minus;
  const TrendIcon = trendIcon;
  const trendColor = trend > 0 ? "#10B981" : trend < 0 ? "#EF4444" : "#94A3B8";

  return (
    <div data-testid={testId} className="hah-card p-5 flex flex-col gap-3 transition-transform hover:-translate-y-[1px]">
      <div className="flex items-start justify-between">
        <div
          className="w-10 h-10 rounded-lg flex items-center justify-center"
          style={{ background: `${accent}14` }}
        >
          {Icon && <Icon className="w-5 h-5" style={{ color: accent }} strokeWidth={2} />}
        </div>
        {trend !== undefined && (
          <div
            className="flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full"
            style={{ background: `${trendColor}14`, color: trendColor }}
          >
            <TrendIcon className="w-3 h-3" />
            <span>{Math.abs(trend)}%</span>
          </div>
        )}
      </div>
      <div>
        <div className="text-[11px] tracking-wider uppercase font-semibold text-[#6B7280]">
          {typeof label === "string" ? t(label) : label}
        </div>
        <div className="mt-1 text-[28px] leading-none font-semibold text-[#1F2937]">
          {value}
        </div>
        {trendLabel && (
          <div className="mt-1 text-xs text-[#6B7280]">{typeof trendLabel === "string" ? t(trendLabel) : trendLabel}</div>
        )}
      </div>
    </div>
  );
}
